<template>
  <div class="welcomeCard">
    <div class="welcomeCard__leftSection">
      <h3>Velkommen til Husleie.no!</h3>

      <p class="mt-4">
        Vi er her for å støtte deg gjennom hele utleiereisen. Ta en titt rundt, og hvis du har spørsmål, ikke nøl med å
        kontakte vår kundesupport. Vi ser frem til å hjelpe deg med å lykkes som utleier.
      </p>

      <p class="mt-4">
        <button class="btn btn-primary" @click="goToSubscriptionView">Les mer om våre tjenester</button>
      </p>
    </div>
    <div class="welcomeCard__rightSection">
      <div class="welcomeCard__rightSection__absolute">
        <div class="welcomeCard__rightSection__absolute__benefits">
          <div v-for="(benefit, index) in benefits" :key="index" class="d-flex align-items-center pr-4">
            <span>
              <i class="budicon-check-ui" />
            </span>
            <span class="ml-1">{{ benefit }}</span>
          </div>
          <div class="welcomeCard__rightSection__absolute__benefits__bottom">
            <span>Og mye mer..</span>
            <div class="d-flex align-items-center">
              <span>Fra kr.</span>
              <h4 class="text-primary ml-1">99</h4>
              <span>/mnd.</span>
            </div>
          </div>
        </div>
      </div>

      <div class="welcomeCard__rightSection__close" @click="$emit('click')">
        <div class="welcomeCard__rightSection__close__container">
          <i class="budicon-cross-ui" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'WelcomeCard',
  props: {
    subscriptionRouteName: {
      type: String,
      required: true,
    },
  },
  computed: {
    benefits() {
      return [
        'Fakturering av husleien',
        'Betalingsoppfølging',
        'Bistand til utkastelse',
        'Depositumskonto',
        'Telefonsupport',
      ];
    },
  },
  methods: {
    goToSubscriptionView() {
      this.$router.push({
        name: this.subscriptionRouteName,
      });
    },
  },
});
</script>

<style lang="scss" scoped>
.welcomeCard {
  display: grid;
  grid-template-columns: 80% 1fr;
  border: 1px solid #80d4b9;
  background: #ecf8f2;
  border-radius: 12px;
}
.welcomeCard__leftSection {
  padding: 2rem;
}
.welcomeCard__rightSection__absolute {
  display: none;
}
.welcomeCard__rightSection__close {
  display: flex;
  justify-content: flex-end;
  padding: 1.2rem;
}
.welcomeCard__rightSection__close__container {
  display: flex;
  justify-content: center;
  padding: 0.2rem;
  background: white;
  border-radius: $border-radius;
  z-index: 1;
  cursor: pointer;
}
.welcomeCard__rightSection__close__container i {
  font-size: 1.5rem;
  color: black;
}

@media (min-width: 887px) {
  .welcomeCard {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    border: 1px solid #80d4b9;
    background: #ecf8f2;
  }
  .welcomeCard__rightSection {
    position: relative;
  }
  .welcomeCard__rightSection__close {
    display: flex;
    justify-content: flex-end;
  }
  .welcomeCard__rightSection__close__container {
    display: flex;
    justify-content: center;
    padding: 0.2rem;
    background: white;
    border-radius: $border-radius;
    z-index: 1;
    cursor: pointer;
  }
  .welcomeCard__rightSection__close__container i {
    font-size: 1.5rem;
    color: black;
  }
  .welcomeCard__rightSection__absolute {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    height: 100%;
    width: 100%;
    background-image: linear-gradient(to right, #ecf8f2, rgba(255, 255, 255, 0) 75%),
      url('../../assets/subscription/welcome-card.png');
    background-size: cover;
    border-radius: 12px;
  }
  .welcomeCard__rightSection__absolute__benefits {
    background: white;
    border-left: 4px solid $primary;
    border-radius: $border-radius;
    padding: 1.5rem;
    width: initial;
    position: absolute;
    margin-left: 2rem;
  }
  .welcomeCard__rightSection__absolute__benefits__bottom {
    display: block;
    margin-left: 1.8rem;
  }
  .welcomeCard__rightSection__absolute__benefits i {
    font-size: 1.5rem;
    color: $primary;
  }
}

@media (min-width: 1200px) {
  .welcomeCard {
    display: grid;
    grid-template-columns: minmax(0%, 60%) 1fr;
    border: 1px solid #80d4b9;
    background: #ecf8f2;
  }
  .welcomeCard__rightSection {
    position: relative;
  }
  .welcomeCard__rightSection__close {
    display: flex;
    justify-content: flex-end;
  }
  .welcomeCard__rightSection__close__container {
    display: flex;
    justify-content: center;
    padding: 0.2rem;
    background: white;
    border-radius: $border-radius;
    z-index: 1;
    cursor: pointer;
  }
  .welcomeCard__rightSection__close__container i {
    font-size: 1.5rem;
    color: black;
  }
  .welcomeCard__rightSection__absolute {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: absolute;
    height: 100%;
    width: 100%;
    background-image: linear-gradient(to right, #ecf8f2, rgba(255, 255, 255, 0) 75%),
      url('../../assets/subscription/welcome-card.png');
    background-size: cover;
  }
  .welcomeCard__rightSection__absolute__benefits {
    background: white;
    border-left: 4px solid $primary;
    border-radius: $border-radius;
    padding: 1.5rem;
    width: 320px;
    position: absolute;
    margin-left: 2rem;
  }
  .welcomeCard__rightSection__absolute__benefits__bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 1.8rem;
  }
  .welcomeCard__rightSection__absolute__benefits i {
    font-size: 1.5rem;
    color: $primary;
  }
}
</style>
